// src/components/NotAuthorised.jsx
import React from "react";

export default function NotAuthorised() {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <h1 className="text-3xl font-semibold text-red-600">
        403 – Not authorised
      </h1>
    </div>
  );
}
